import angular from 'angular'
import './logs.service'

angular.module('admin.logs', ['admin.logs.service']).controller('LogsAdminCtrl', LogsAdminCtrl)

/** @ngInject */
function LogsAdminCtrl($scope, $rootScope, LogsService, UsersService) {
  var vm = this
  vm.logs = []
  vm.users = []
  $rootScope.page = 'Product Logs'

  UsersService.getAll().then(function(result) {
    vm.users = result.results
  })

  var watch = $scope.$watch('vm.userID', function(newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    LogsService.getProductLogUser(newVal).then(function(result) {
      vm.logs = result.results
    })
  })

  $scope.$on('$destroy', function() {
    watch()
  })
}
